import React, { useEffect, useState } from "react";
import Template from "../../utils/Template";
import Card from "../../utils/Card";
import TableScroll from "../../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../../utils/Table";
import Pagination from "../../utils/Pagination";
import { decodeData, errorToaster, formatDate } from "../../utils/Helper";
import { useNavigate, useParams } from "react-router-dom";
import { getMethod } from "../../service";
import ConfirmModal from "../../utils/modals/ConfirmModal";
import moment from "moment";
import { SESSION_REPORT_API } from "../../service/constant";
import Input from "../../utils/Input";
import SubmitBtn from "../../utils/SubmitBtn";

const SessionReportDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [bettings, setBettings] = useState([]);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const navigate = useNavigate();
  const [showDetail, setShowDetail] = useState(false);
  const [detailData, setDetailData] = useState("");
  const [betDetail, setBetDetail] = useState("");
  const [result, setResult] = useState({});
  const [searchId, setSearchId] = useState("");

  const params = useParams();

  const fetchBetting = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    const result_id = params.result_id;

    if (!result_id) {
      navigate(-1);
      return;
    }

    if (token) {
      const res = await getMethod(
        `${SESSION_REPORT_API}?page=${page}&limit=50&search=${searchId}&result_id=${result_id}`,
        token.token
      );
      if (res?.isSuccess) {
        setResult(res.result);
        setIsLoading(false);
        setBettings(res?.data);
        setFrom((res?.meta?.current_page - 1) * 50);
        setTotalPage(res?.meta?.last_page);
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  useEffect(() => {
    fetchBetting();
  }, [refs, page]);

  return (
    <Template
      title={"Session Report Details - " + params.result_id}
      isLoading={isLoading}
    >
      <div className="row">
        <div className="col-sm-6 col-lg-3 mb-3">
          <div className="card card-hover-shadow h-100">
            <div className="card-body">
              <h6 className="card-subtitle">Total Bet</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {result?.total_bet?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-lg-3 mb-3">
          <div className="card card-hover-shadow h-100">
            <div className="card-body">
              <h6 className="card-subtitle">Total Payout</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {result?.total_payout?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-lg-3 mb-3">
          <div className="card card-hover-shadow h-100">
            <div className="card-body">
              <h6 className="card-subtitle">Total Profit</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    <div
                      className={`${
                        result?.total_payout > result?.total_bet
                          ? "text-danger"
                          : "text-success"
                      } mb-1`}
                    >
                      {(
                        result.total_bet - result.total_payout
                      )?.toLocaleString()}{" "}
                    </div>
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={searchId}
              event={(e) => setSearchId(e.target.value)}
              placeholder="Search User Name OR Phone"
            />
          </div>

          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Number</th>
              <th>Bet</th>
              <th>Odds</th>
              <th>Payout</th>
              <th>Time</th>
            </TableHeader>
            <TableBody>
              {bettings.length > 0 &&
                bettings.map((betting, i) => (
                  <tr
                    key={betting._id}
                    className={`${
                      betting?.bet_status === "win" ? "tbody-bg-success" : ""
                    }`}
                  >
                    <td>{i + 1}.</td>
                    <td>{betting?.name || betting?.userId?.name}</td>
                    <td>{betting?.phone || betting?.userId?.phone}</td>
                    <td className="text-center">{betting.betNumber}</td>
                    <td className="text-end">
                      {betting.amount.toLocaleString("en-us")}
                    </td>
                    <td>{betting.odds.toLocaleString("en-us")}</td>
                    <td className="text-end">
                      {betting.payout.toLocaleString("en-us")}
                    </td>
                    <td>
                      {moment(betting.createdAt)
                        .utc()
                        .format("DD-MM-YYYY, hh:mm:ss A")}
                    </td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
      {showDetail && (
        <ConfirmModal
          name={"Bet Detail"}
          isLoading={isLoading}
          onClose={() => {
            setShowDetail(false);
            setDetailData("");
            setBetDetail("");
          }}
          onSubmit={() => {
            setShowDetail(false);
            setDetailData("");
            setBetDetail("");
          }}
        >
          <ul>
            {betDetail.length > 0 &&
              betDetail.map((detail, i) => <li key={i}>{detail}</li>)}
          </ul>
        </ConfirmModal>
      )}
    </Template>
  );
};

export default SessionReportDetails;
